import { render } from "./FilterBtn.vue?vue&type=template&id=1f8e49be"
import script from "./FilterBtn.vue?vue&type=script&lang=js"
export * from "./FilterBtn.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__